import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useListing } from "@/providers";
import { DetailsPage } from "@/Pages/details/DetailsPage";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import { axiosInstanceWithToken } from "@/helpers/axios";

export const DetailsFragment = () => {
  const { id } = useParams();
  const stripePromise = loadStripe(
    process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY
  );

  const [pageLoading, setPageLoading] = useState(true);
  const [reviews, setReviews] = useState([]);
  const { getListingById, listingDetails, similarListings, hostListings } =
    useListing();

  useEffect(() => {
    // fetchData();
    getListingById(id).then(() => {
      axiosInstanceWithToken
        .get(`/listing-reviews?type=GUEST_TO_BOOKING&listing_id=${id}`)
        .then((response) => {
          setReviews(response.data?.data || []);
          setPageLoading(false);
        });
    });
  }, [getListingById, id]);

  if (pageLoading) {
    return (
      <div className="flex flex-col items-center justify-center h-screen gap-5">
        <img
          className="h-auto w-36 md:w-44" // Responsive sizes
          src="/image/fly-inn-logo.svg"
          alt="Fly Inn Logo"
        />
        <div className="text-2xl text-bold">
          {" "}
          Please Wait while we load your data!
        </div>
      </div>
    );
  }

  return (
    <Elements stripe={stripePromise}>
      <DetailsPage
        listingDetails={{
          ...listingDetails,
          reviews,
          similarListings,
          hostListings,
        }}
      />
    </Elements>
  );
};
